import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]获取图片列表-获取兜底数据
 */
export function getAdPicListUsingPOST(
  req: AdPicManageDto | void,
  config?: RequestConfig
): Promise<ApiResultListAdPicManageParam> {
  return resource.postNoAuth('/adPicManage/adPicList', req, config);
}

/**
 * [No Auth]基金推荐位-获取兜底数据
 */
export function getFundRecommendUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListFundListInTab> {
  return resource.postNoAuth('/adPicManage/fundRecommend', req, config);
}

/**
 * [No Auth]获取MA推荐图片列表
 */
export function getMaAdPicListUsingPOST(
  req: AdPicManageDto | void,
  config?: RequestConfig
): Promise<ApiResultListAdPicManageParam> {
  return resource.postNoAuth('/adPicManage/maAdPicList', req, config);
}

/**
 * [No Auth]MA基金推荐位
 */
export function getMaFundRecommendUsingPOST(
  req: MaQueryParam | void,
  config?: RequestConfig
): Promise<ApiResultListFundListInTab> {
  return resource.postNoAuth('/adPicManage/maFundRecommend', req, config);
}
